import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import GeneratePaymentRequest from "../GeneratePaymentRequest";
import { getParam } from "../../../utils/functions";
import { getPaymentSummary } from "../../../store/Concept/actions";

const PaymentDetail = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPaymentSummary(getParam("id")));
  }, []);

  return <GeneratePaymentRequest id={getParam("id")} detail={true} />;
};

export default PaymentDetail;
